export const AGENT_SCHEDULE_IMPORT_TABLE_UNIQUE_ID = 'agent-schedule-import';

export const AGENT_SCHEDULE_IMPORT_TABLE_ROW_HEIGHT = 48;

export const NO_ERRORS_EMPTY_STATE_TEXT = 'Very good! you dont have any errors to fix';
export const NO_MATCHING_TYPES_EMPTY_STATE_TEXT = 'No rows match the selected types';

/**
 * Initial width of every column of the agent schedule import table, keyed by the same `col-*`
 * class the header and row cells in agent-schedule-import-table.html carry.
 *
 * Keep in sync with agent-schedule-import-table.scss.
 */
export const AGENT_SCHEDULE_IMPORT_TABLE_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-row': 60,
  'col-name': 260,
  'col-agent': 140,
  'col-type': 100,
  'col-timezone': 160,
  'col-program-type': 120,
  'col-branch-ids': 140,
  'col-service-area-ids': 150,
  'col-date': 110,
  'col-start-time': 90,
  'col-end-time': 90,
  'col-freq': 90,
  'col-recurring-start-date': 150,
  'col-recurring-end-date': 150,
  'col-interval': 80,
  'col-by-week-day': 140,
  'col-absence-reason': 150
};

export interface AgentScheduleColumnSetting {
  key: string;
  label: string;
  enabled: boolean;
}

export type AgentScheduleColumns = { [key: string]: AgentScheduleColumnSetting };

/**
 * The user-toggleable columns (Row and Name are structural and always shown), in the order
 * they should appear in both the table and the columns settings panel.
 */
export const AGENT_SCHEDULE_TOGGLEABLE_COLUMNS: AgentScheduleColumns = {
  agent: {key: 'agent', label: 'Agent', enabled: true},
  type: {key: 'type', label: 'Type', enabled: true},
  timezone: {key: 'timezone', label: 'Time Zone', enabled: true},
  programType: {key: 'programType', label: 'Program Type', enabled: true},
  branchIds: {key: 'branchIds', label: 'Branch Ids', enabled: true},
  serviceAreaIds: {key: 'serviceAreaIds', label: 'Service Area Ids', enabled: true},
  date: {key: 'date', label: 'Date', enabled: true},
  startTime: {key: 'startTime', label: 'Start Time', enabled: true},
  endTime: {key: 'endTime', label: 'End Time', enabled: true},
  freq: {key: 'freq', label: 'Freq', enabled: true},
  recurringStartDate: {key: 'recurringStartDate', label: 'Recurring Start Date', enabled: true},
  recurringEndDate: {key: 'recurringEndDate', label: 'Recurring End Date', enabled: true},
  interval: {key: 'interval', label: 'Interval', enabled: true},
  byWeekDay: {key: 'byWeekDay', label: 'By Week Day', enabled: true},
  absenceReason: {key: 'absenceReason', label: 'Absence Reason', enabled: true}
};
